<template>
  <div eagle-form-item="textarea" class="my-2">
    <v-textarea
      v-if="!readonly"
      dense
      solo
      flat
      outlined
      :disabled="disabled"
      :maxlength="maxlength"
      :error="!!error"
      :error-messages="error"
      :rules="vuetifyRules"
      :autofocus="focus"
      :counter="!disabled && !readonly"
      v-model="data"
      class="linerp-textarea"
    ></v-textarea>

    <div v-else>
      {{ data }}
    </div>
  </div>
</template>

<script lang="babel" type="text/babel">
import formTextType from '@/components/form/formItemTypes/formTextType'
export default {
  mixins: [formTextType],
  computed: {
    maxlength() {
      return this.formDataItem.maxlength || 150
    },
  },
}
</script>

<style lang="sass" type="text/sass">

</style>